module.exports = __webpack_public_path__ + "media/images/relevant-c529c59e00b62cbadb1a41640a4d1411.png";